module.exports = __webpack_public_path__ + "img/search-list.1ff773dd.svg";